type PriceCondition = (priceValue: number, comparisonValue: number) => boolean;

interface PriceDefaults {
  CONDITION: PriceCondition;
  RANGE: HTMLOptionElement[];
}

const PRICE_DEFAULTS: { MAX_PRICE: PriceDefaults; MIN_PRICE: PriceDefaults } = {
  MAX_PRICE: {
    CONDITION: (priceValue: number, maxValue: number): boolean =>
      priceValue < maxValue,
    RANGE: [],
  },
  MIN_PRICE: {
    CONDITION: (priceValue: number, minValue: number): boolean =>
      priceValue > minValue,
    RANGE: [],
  },
};

const updatePriceOptions = (
  targetSelect: HTMLSelectElement,
  sourceSelect: HTMLSelectElement,
  defaults: PriceDefaults
): void => {
  const selectedValue = parseInt(sourceSelect.value);
  const firstOption = targetSelect.options[0].cloneNode(
    true
  ) as HTMLOptionElement;
  const options = Array.from(defaults.RANGE);
  const previousValue = targetSelect.value;
  const condition = isNaN(selectedValue)
    ? () => true
    : (priceValue: number) => defaults.CONDITION(priceValue, selectedValue);

  const populateOptions = (): void => {
    const fragment = document.createDocumentFragment();
    fragment.appendChild(firstOption);

    options.forEach((option) => {
      const priceValue = parseInt(option.value);
      if (!isNaN(priceValue) && condition(priceValue)) {
        fragment.appendChild(option.cloneNode(true));
      }
    });

    targetSelect.innerHTML = '';
    targetSelect.appendChild(fragment);
  };

  populateOptions();

  const newValue = Array.from(targetSelect.options).some(
    (option) => option.value === previousValue
  )
    ? previousValue
    : '';
  targetSelect.value = newValue;
};

const setupPriceSelector = (
  sourceSelect: HTMLSelectElement,
  targetSelect: HTMLSelectElement,
  defaults: PriceDefaults
): void => {
  sourceSelect.addEventListener('change', () => {
    updatePriceOptions(targetSelect, sourceSelect, defaults);
  });
};

const priceSelector = (): void => {
  const minPriceSelect = document.getElementById(
    'min_price'
  ) as HTMLSelectElement;
  const maxPriceSelect = document.getElementById(
    'max_price'
  ) as HTMLSelectElement;

  PRICE_DEFAULTS.MIN_PRICE.RANGE = Array.from(minPriceSelect.options);
  PRICE_DEFAULTS.MAX_PRICE.RANGE = Array.from(maxPriceSelect.options);

  setupPriceSelector(minPriceSelect, maxPriceSelect, PRICE_DEFAULTS.MIN_PRICE);
  setupPriceSelector(maxPriceSelect, minPriceSelect, PRICE_DEFAULTS.MAX_PRICE);
};

export default priceSelector;
